<template>
  <div>
    <!-- <main-layout> -->
    <v-container>
      <div class="text-xs-center" style="padding-top:2em">
        <h2 style="display: inline;">{{ $t('Redeem Code') }}</h2>
        <a href="https://tinyurl.com/yc5khjmj" target="blank"
          ><i style="font-size: 18px; color: #ed1e79;" class="fas fa-question-circle"></i
        ></a>
        <p>
          {{ $t("Fill in if you have 'redeem or support code' from ZWIZ.AI's official partners") }}
        </p>
      </div>
      <div v-if="loading" class="spinner text-xs-center">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
      <template v-else-if="supportDetail">
        <p>{{ $t('If you have any question, contact your supporter here') }}</p>
        <div class="z-border-red pa-2 mb-3">
          <v-list-tile avatar>
            <v-list-tile-avatar>
              <img :src="supportDetail.photo" @error="onError" />
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title v-html="supportDetail.fullname"></v-list-tile-title>
              <v-list-tile-sub-title v-html="supportDetail.contact"></v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </div>
      </template>
      <div class="form-control text-xs-center">
        <redeem-code></redeem-code>
      </div>
    </v-container>
    <!-- </main-layout> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
import api from '@/api'
import RedeemCode from '@/components/elements/RedeemCode'

export default {
  data() {
    return {
      RedeemCodecode: null,
      supportDetail: null,
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  components: {
    VueRecaptcha,
    RedeemCode
  },
  directives: {
    uppercase: {
      update(el) {
        el.value = el.value.toUpperCase()
      }
    }
  },
  mounted: function() {
    var vm = this
    vm.$store.dispatch('updateBotDetail').then(
      function() {
        if (vm.selectedBot.supportusers) {
          vm.loading = true
          vm.getSupportUser().then(
            function() {
              vm.loading = false
            },
            function() {
              vm.loading = false
            }
          )
        } else {
          vm.loading = false
        }
      },
      function() {
        vm.loading = false
      }
    )
  },
  methods: {
    onError: function(event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    getSupportUser: function() {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          supportusers: vm.selectedBot.supportusers
        }
        api.getSupportUser(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            vm.supportDetail = response.data
          }
          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/redeem/redeemcode.vue